import { Injectable, inject } from '@angular/core';
import { FormBuilder, type FormGroup, type FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class PreferenceFormService {
  readonly #fb = inject(FormBuilder);
  form: FormGroup = this.#fb.group({});

  /**
   * Initialize form controls dynamically based on consent array
   * @param consentArray Array of consent strings
   * @param defaultValue Default value for all checkboxes (defaults to true)
   */
  public initializeFormControls(consentArray: string[], defaultValue = true): void {
    const formControls: Record<string, FormControl<boolean | null>> = {};
    consentArray.forEach((consent) => {
      formControls[consent] = this.#fb.control<boolean | null>(defaultValue);
    });
    this.form = this.#fb.group(formControls);
  }
}
